import React, { memo } from 'react';
import { useRecoilValue } from 'recoil';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@mui/material';
import { Luggage } from '@mui/icons-material';
import { CarModel, InnerCargo } from 'models/StockModel';
import auth from 'recoil/atoms/auth';
import { FakePromise } from 'utils/common';


type CarCargoCellProps = {
    car: CarModel,
    openInnerCargoModal: (car: CarModel) => FakePromise<any>,
}

const CarCargoCell = ({car, openInnerCargoModal}: CarCargoCellProps) => {
    const my = useRecoilValue(auth)
    const { t } = useTranslation();
    const hasTextCargo = car.albums.findIndex(a => a.name === 'yard_cargo' && a.note) > -1;

    return (
        <Tooltip
            title={car.innerCargo.length > 0 ? <>
                {car.innerCargo.map((ic: InnerCargo) => (
                    <div key={ic.name}>{ic.name} &times; {ic.quantity}</div>
                ))}
            </> : my.permissions.has('cars update cargo') ? t('add_title', {value: t('inner_cargo')}) : null}
            placement="top"
        >
            <Luggage
                color={car.innerCargo.length > 0 ? undefined : (hasTextCargo ? 'error' : 'disabled')}
                sx={{verticalAlign: 'middle'}}
                onClick={() => (my.permissions.has('cars update cargo') || car.innerCargo.length) && openInnerCargoModal(car)}
            />
        </Tooltip>
    );
};

export default memo(CarCargoCell);
